if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"main","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(35[34]|6(84|87|95)|098|477|524|572|763|910)|2(8(08|49|58)|397|460|726)|3(0[028]|371|408|724|796|860)|4(280|449|668)|5(059|244|420|460|762|948)|6((04|26|37)1|097|178|2|395|48|52)|7((58|6|87)0|036|513|98)|8((24|38|72)4|168|361|592|640|988)|9(086|121|148|415|657|67|714|853))$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}